'use client'

import Paper from '@mui/material/Paper'

import { useSlugnifier } from '@Server/app/utils/slugnifier'

export default function Page() {
  const { last } = useSlugnifier()
  return (
    <>
      {/* @body/page/ */}
      <Paper>
        <span className="layout-body">
          {last || 'home'}
        </span>
      </Paper>
      <section>
        <span className="body-container">
          -root-
        </span>
      </section>
    </>
  )
}
